// extracted by mini-css-extract-plugin
export default {"container":"bI-z","header":"cI-z","details":"dI-z","link":"eI-z"};